export const PANEL_ATTRIBUTES = [
    { attribute: 'material', label: 'Frame Material', isNewFacet: true },
    { attribute: 'frame_type', label: 'Frame Type', isNewFacet: true },
    { attribute: 'color', label: 'Color', isNewFacet: true },
    { attribute: 'decor_style', label: 'Decor Style', isNewFacet: true },
    { attribute: 'rabbet_depth', label: 'Rabbet Depth', isNewFacet: true },
    { attribute: 'frame_width', label: 'Frame Width', isNewFacet: true },
    { attribute: 'substrates', label: 'Art Type', isNewFacet: true },
    { attribute: 'finish', label: 'Frame Finish', isNewFacet: true },
    { attribute: 'art_sizes', label: 'Image / Art Size', isNewFacet: true },
    { attribute: 'sale', label: 'Clearance', isNewFacet: true }
];
